import { render, staticRenderFns } from "./ticket-collectuser-list.vue?vue&type=template&id=4e43d4ab&"
import script from "./ticket-collectuser-list.vue?vue&type=script&lang=js&"
export * from "./ticket-collectuser-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports